interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: Props) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-sm font-medium tracking-wide text-primary-600">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}